module.exports = __webpack_public_path__ + "img/44.bed23e5d.jpg";